import React, { Component } from "react";
import * as firebase from "firebase";

import { Bounce } from "react-activity";
import Select from "react-select";
import "react-activity/dist/react-activity.css";

class Register extends Component {
  state = {
    cadastrado: false,
    loading: false,
    servicosSearch: [
      {
        value: "05",
        label: "05",
      },
      {
        value: "10",
        label: "10",
      },
      {
        value: "15",
        label: "15",
      },
      {
        value: "20",
        label: "20",
      },
      {
        value: "25",
        label: "25",
      },
    ],
    selectedOption: null,
  };

  componentDidMount() {
    this.email = "";
    this.password = "";
    this.passwordConfirmation = "";
    this.name = "";
    this.cpf = "";
    this.fone = "";
    this.fone2 = "";
    this.adress = "";
    this.carID = "";
    this.carID2 = "";
    this.carID3 = "";

    this.plan = "";
    this.ativationDate = "";
    this.paymentDate = "";
    this.paymentType = "";
  }

  handleChangeDropdown = (selectedOption) => {
    this.setState({ selectedOption });
    this.paymentDate = selectedOption.value;
  };

  updatePlan = (evt) => {
    this.plan = evt.target.value;
  };

  updateAtivationDate = (evt) => {
    this.ativationDate = evt.target.value;
  };

  updatePaymentDate = (evt) => {
    this.paymentDate = evt.target.value;
  };

  updatePaymentType = (evt) => {
    this.paymentType = evt.target.value;
  };

  updateName = (evt) => {
    this.name = evt.target.value;
  };

  updateEmail = (evt) => {
    this.email = evt.target.value;
  };

  updatePassword = (evt) => {
    this.password = evt.target.value;
  };

  updatePasswordConfirmation = (evt) => {
    this.passwordConfirmation = evt.target.value;
  };

  updateCPF = (evt) => {
    this.cpf = `${evt.target.value}`;
  };

  updateFone = (evt) => {
    this.fone = `${evt.target.value}`;
  };

  updateFone2 = (evt) => {
    this.fone2 = `${evt.target.value}`;
  };

  updateAdress = (evt) => {
    this.adress = evt.target.value;
  };

  updateCarId = (evt) => {
    this.carID = evt.target.value;
  };

  updateCarId2 = (evt) => {
    this.carID = evt.target.value;
  };

  updateCarId3 = (evt) => {
    this.carID = evt.target.value;
  };

  base64Encode = (email) => {
    return btoa(email);
  };

  base64Decode = (base64) => {
    return atob(base64);
  };
  /** 
  showPosition = position => {
    this.lat = position.coords.latitude;
    this.lon = position.coords.longitude;

    if (this.password !== this.passwordConfirmation) {
      alert("As senhas não correspondem");
      this.setState({ loading: false });
    } else {
      if (
        this.email !== "" &&
        this.password !== "" &&
        this.name !== "" &&
        this.cpf !== "" &&
        this.fone !== "" &&
        this.adress !== ""         
      ) {
        let secureEmail = this.email.toLowerCase();
        firebase
          .auth()
          .createUserWithEmailAndPassword(secureEmail, this.password)
          .then(user => {
            this.registerOnDatabase(secureEmail);
          })
          .catch(erro => {
            this.erroRegisterHandle(erro);
          });
      } else {
        alert("Preencha todos os campos");
        this.setState({ loading: false });
      }
    }
  };
  */

  register = () => {
    this.setState({ loading: true });

    this.lat = -16.001;
    this.lon = -49.001;

    if (this.password !== this.passwordConfirmation) {
      alert("As senhas não correspondem");
      this.setState({ loading: false });
    } else {
      if (
        this.email !== "" &&
        this.password !== "" &&
        this.name !== "" &&
        this.cpf !== "" &&
        this.fone !== "" &&
        this.adress !== "" &&
        this.paymentDate !== ""
      ) {
        let secureEmail = this.email.toLowerCase();
        firebase
          .auth()
          .createUserWithEmailAndPassword(secureEmail, this.password)
          .then((user) => {
            this.registerOnDatabase(secureEmail);
          })
          .catch((erro) => {
            this.erroRegisterHandle(erro);
          });
      } else {
        alert("Preencha todos os campos");
        this.setState({ loading: false });
      }
    }
  };

  registerOnDatabase(secureEmail) {
    let emailBase64 = this.base64Encode(secureEmail);
    firebase
      .database()
      .ref(`/casas/${emailBase64}`)
      .set({
        nome: this.name,
        lat: this.lat,
        lon: this.lon,
        cpf: this.cpf,
        fone: this.fone,
        fone2: this.fone2,
        adress: this.adress,
        carId: this.carID,
        carId2: this.carID2,
        carId3: this.carID3,
        plan: this.plan,
        ativationDate: this.ativationDate,
        paymentDate: this.paymentDate,
        paymentType: this.paymentType,
        hasRonda: "no",
        order: 1,
        inOutCalls: 0,
        inOutCallsByMonth: 4,
        hasPaid: true,
        hasInOut: true,
        hasPanic: true,
        panicCallsByMonth: 4,
        panicCalls: 0,
      })
      .then((value) => {
        this.setState({ cadastrado: true });
        this.setState({ loading: false });
      })
      .catch((erro) => {
        this.setState({ loading: false });
        console.log(erro);
        alert(
          "Não foi possivel efetuar seu cadastro, verifique sua conexão com a internet"
        );
      });
  }

  erroRegisterHandle(erro) {
    this.setState({ loading: false });
    switch (erro.code) {
      case "auth/email-already-in-use":
        alert("Este email já está em uso");
        break;
      case "auth/invalid-email":
        alert("Esse email não é válido");
        break;
      case "auth/weak-password":
        alert("A senha precisa ter no minimo 6 caracteres");
        break;
      case "auth/timeout":
        alert("Verifique sua conexão com a internet");
        break;
      default:
        console.log(erro);
        alert(
          "Erro inesperado, tente mais tarde ou entre em contato com a central"
        );
        break;
    }
  }

  renderRegisterOrLoading() {
    if (this.state.loading === false) {
      return (
        <button
          type="button"
          className="btn btn-primary"
          onClick={this.register}
        >
          Cadastrar-se
        </button>
      );
    }
    return <Bounce />;
  }

  renderAccount() {
    if (this.state.cadastrado === false) {
      return (
        <div className="container">
          <form method="POST">
            nome(Obrigatorio):
            <br />
            <input
              type="text"
              name="name"
              className="form-control"
              onChange={this.updateName}
            />
            CPF(Obrigatorio) apenas números:
            <br />
            <input
              type="number"
              name="name"
              className="form-control"
              onChange={this.updateCPF}
            />
            Endereço(Obrigatorio):
            <br />
            <input
              type="text"
              name="name"
              className="form-control"
              onChange={this.updateAdress}
            />
            Telefone(Obrigatorio):
            <br />
            <input
              type="number"
              name="name"
              className="form-control"
              onChange={this.updateFone}
            />
            Telefone secundário:
            <br />
            <input
              type="number"
              name="name"
              className="form-control"
              onChange={this.updateFone2}
            />
            Placa do carro principal:
            <br />
            <input
              type="text"
              name="name"
              className="form-control"
              onChange={this.updateCarId}
            />
            Placa do carro secundário:
            <br />
            <input
              type="text"
              name="name"
              className="form-control"
              onChange={this.updateCarId2}
            />
            Placa do carro terciário:
            <br />
            <input
              type="text"
              name="name"
              className="form-control"
              onChange={this.updateCarId3}
            />
            Plano escolhido (Obrigatorio):
            <input
              type="text"
              name="name"
              className="form-control"
              onChange={this.updatePlan}
            />
            Data da efetivação (Obrigatorio):
            <input
              type="text"
              name="name"
              className="form-control"
              onChange={this.updateAtivationDate}
            />
            Data para pagamento (Obrigatorio):
            <br />
            <Select
              //styles={customStyles}
              value={this.state.selectedOption}
              onChange={this.handleChangeDropdown}
              options={this.state.servicosSearch}
            />
            Forma de pagamento (Obrigatorio):
            <br />
            <input
              type="text"
              name="name"
              className="form-control"
              onChange={this.updatePaymentType}
            />
            email (Obrigatorio):
            <br />
            <input
              type="email"
              name="email"
              className="form-control"
              onChange={this.updateEmail}
            />
            senha (Obrigatorio):
            <br />
            <input
              type="password"
              name="senha"
              className="form-control"
              onChange={this.updatePassword}
            />
            confirme sua senha:
            <input
              type="password"
              name="senhaConfirmation"
              className="form-control"
              onChange={this.updatePasswordConfirmation}
            />
            <br />
            <div className="row">
              <div className="col-md-2">{this.renderRegisterOrLoading()}</div>
            </div>
          </form>
        </div>
      );
    }
    return (
      <div className="container">
        <h1>Cadastro realizado com sucesso!!!</h1>
        <p>Acesse o aplicativo com seu email e senha criados</p>
      </div>
    );
  }

  render() {
    return this.renderAccount();
  }
}

export default Register;
